import { COURSE_FILTER_PAGE_SIZE } from '../constants';
import { RequestStatus } from '../../data/constants';
import {
  getStudioHomeData,
  sendRequestForCourseCreator,
  handleCourseNotification,
  getStudioHomeCourses,
  getStudioHomeLibrariesV2,
  getStudioHomeCoursesV2,
  getStudioHomeReleasedLanguages,
} from './api';
import {
  fetchStudioHomeDataSuccess,
  fetchCourseDataSuccess,
  updateLoadingStatuses,
  updateSavingStatuses,
  fetchLibraryDataSuccessV2,
  fetchLibraryFilterCoursesSuccess,
  fetchCourseFilterLanguagesSuccess,
  fetchCourseDataSuccessV2,
  updateStudioHomeLibrariesCustomParams,
} from './slice';

function fetchStudioHomeData(search, hasHomeData, requestParams = {}, isPaginationEnabled = false) {
  return async (dispatch) => {
    dispatch(updateLoadingStatuses({ studioHomeLoadingStatus: RequestStatus.IN_PROGRESS }));
    dispatch(updateLoadingStatuses({ courseLoadingStatus: RequestStatus.IN_PROGRESS }));

    if (!hasHomeData) {
      try {
        const studioHomeData = await getStudioHomeData();
        dispatch(fetchStudioHomeDataSuccess(studioHomeData));
        dispatch(updateLoadingStatuses({ studioHomeLoadingStatus: RequestStatus.SUCCESSFUL }));
      } catch (error) {
        dispatch(updateLoadingStatuses({ studioHomeLoadingStatus: RequestStatus.FAILED }));
        return;
      }
    }
    try {
      if (isPaginationEnabled) {
        const coursesData = await getStudioHomeCoursesV2(search || '', requestParams);
        dispatch(fetchCourseDataSuccessV2(coursesData));
      } else {
        const coursesData = await getStudioHomeCourses(search || '');
        dispatch(fetchCourseDataSuccess(coursesData));
      }

      dispatch(updateLoadingStatuses({ courseLoadingStatus: RequestStatus.SUCCESSFUL }));
    } catch (error) {
      dispatch(updateLoadingStatuses({ courseLoadingStatus: RequestStatus.FAILED }));
    }
  };
}

function fetchLibraryData(requestParams = {}) {
  return async (dispatch) => {
    dispatch(updateLoadingStatuses({ libraryLoadingStatus: RequestStatus.IN_PROGRESS }));

    try {
      const libraryData = await getStudioHomeLibrariesV2(requestParams);
      dispatch(fetchLibraryDataSuccessV2(libraryData));
      dispatch(updateLoadingStatuses({ libraryLoadingStatus: RequestStatus.SUCCESSFUL }));
    } catch (error) {
      dispatch(updateLoadingStatuses({ libraryLoadingStatus: RequestStatus.FAILED }));
    }
  };
}

function fetchLibraryFilterCourses(language) {
  return async (dispatch, getState) => {
    try {
      const allCourses = [];
      let page = 1;
      let numPages = 1;

      do {
        const requestParams = {
          page,
          page_size: COURSE_FILTER_PAGE_SIZE,
        };
        if (language) {
          requestParams.language = language;
        }
        const coursesData = await getStudioHomeCoursesV2('', requestParams);
        allCourses.push(...coursesData.results.courses);
        numPages = coursesData.numPages;
        page += 1;
      } while (page <= numPages);

      dispatch(fetchLibraryFilterCoursesSuccess({
        results: { courses: allCourses },
      }));

      // Preserve selected course if still in options; otherwise clear it.
      const { course, search, order, language: currentLanguage } = (
        getState().studioHome.studioHomeLibrariesRequestParams
      );
      if (course && !allCourses.some((c) => c.courseKey === course)) {
        dispatch(updateStudioHomeLibrariesCustomParams({ course: undefined }));
        dispatch(fetchLibraryData({
          search,
          order,
          language: currentLanguage,
          course: undefined,
        }));
      }
    } catch (error) {
      // Course filter dropdown degrades gracefully when the list cannot be loaded.
    }
  };
}

function fetchCourseFilterLanguages() {
  return async (dispatch) => {
    try {
      const languages = await getStudioHomeReleasedLanguages();
      dispatch(fetchCourseFilterLanguagesSuccess({ languages }));
    } catch (error) {
      // Language filter dropdown degrades gracefully when the list cannot be loaded.
    }
  };
}

function handleDeleteNotificationQuery(url) {
  return async (dispatch) => {
    dispatch(updateSavingStatuses({ deleteNotificationSavingStatus: RequestStatus.PENDING }));

    try {
      await handleCourseNotification(url);
      dispatch(updateSavingStatuses({ deleteNotificationSavingStatus: RequestStatus.SUCCESSFUL }));
    } catch (error) {
      dispatch(updateSavingStatuses({ deleteNotificationSavingStatus: RequestStatus.FAILED }));
    }
  };
}

function requestCourseCreatorQuery() {
  return async (dispatch) => {
    dispatch(updateSavingStatuses({ courseCreatorSavingStatus: RequestStatus.PENDING }));

    try {
      await sendRequestForCourseCreator();
      dispatch(updateSavingStatuses({ courseCreatorSavingStatus: RequestStatus.SUCCESSFUL }));
      return true;
    } catch (error) {
      dispatch(updateSavingStatuses({ courseCreatorSavingStatus: RequestStatus.FAILED }));
      return false;
    }
  };
}

export {
  fetchStudioHomeData,
  fetchLibraryData,
  fetchLibraryFilterCourses,
  fetchCourseFilterLanguages,
  requestCourseCreatorQuery,
  handleDeleteNotificationQuery,
};
